'use client';

import { fetchPost, fetchGet } from 'lowcode/utils/service/FetchClient';
import { loginUrl } from 'lowcode/utils/service/baseUrl';

export const rewardRedeemRuleList = async (locale: any, pathUrl?: string) => {
    if (pathUrl) {
        return fetchPost(
            `${loginUrl(locale)}/integral/web/creditsDay/listCouponRule`,
            locale,
            {
                pathUrl,
            },
            {
                needToken: true,
            },
        );
    }
    const res = await fetchPost(`${loginUrl(locale)}/integral/web/rewardRedeemRule/list`, locale);
    return res;
};
export const freeProductRuleList = async (locale: any) => {
    const res = await fetchGet(`${loginUrl(locale)}/integral/web/rewardRedeemRule/freeProductRuleList`, locale);
    return res;
};
// 获取用户积分
export const selectByUserId = async (locale: any) => {
    const res = await fetchGet(`${loginUrl(locale)}/integral/web/rewardUserInfo/selectByUserId`, locale, null, {
        needToken: true,
    });
    return res;
};
